import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'flex h-10 w-full rounded-md border border-brand-border bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-600 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid]:border-danger-border',
					className,
				)}
				{...props}
				ref={ref}
			/>
		)
	},
)
Input.displayName = 'Input'

export { Input }
